import React, { FunctionComponent } from 'react'
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom'
import cn from 'classnames'

type LinkVariant = 'standalone' | 'inline' | 'small' | 'tiny'
type LinkTheme = 'dark'

interface LinkProps {
  variant?: LinkVariant
  theme?: LinkTheme
  className?: string
}

const linkClass = (
  variant: LinkVariant,
  theme?: LinkTheme,
  className?: string
) =>
  cn(
    'wb-link',
    `wb-link--${variant}`,
    theme ? `wb-link--theme-${theme}` : null,
    className
  )

export const ExternalLink: FunctionComponent<
  LinkProps & JSX.IntrinsicElements['a']
> = ({ variant = 'standalone', theme, children, className, ...linkProps }) => (
  <a className={linkClass(variant, theme, className)} {...linkProps}>
    {children}
  </a>
)

export const Link: FunctionComponent<LinkProps & RouterLinkProps> = ({
  variant = 'standalone',
  theme,
  children,
  className,
  ...linkProps
}) => {
  return (
    <RouterLink className={linkClass(variant, theme, className)} {...linkProps}>
      {children}
    </RouterLink>
  )
}
